import React from 'react';
import { ErrorMessage } from 'formik';

import styles from './PaymentFieldsError.module.scss';

export default function PaymentFieldsError(): JSX.Element {
  return (
    <div className={styles.validationError}>
      <ErrorMessage name="paymentMethod" render={msg => <span>{msg}</span>} />
      <ErrorMessage name="cpa" render={msg => <span>{msg}</span>} />
    </div>
  );
}
